import React, {useEffect} from 'react';
import {useConfig} from "../context/ConfigProvider";
import {ThemedButton} from "../index";
import {useTheme} from "../../common/ProjectThemeProvider";
import EVT_ALERT_ICON from "../assets/icons/evt_alert.webp";
// import EVT_ALERT_ICON from "../assets/icons/evt_alert2.webp";

const EventReminderButton = React.memo(({
                                            className = "",
                                            style = {},
                                            onClick,
                                            circular = false,
                                            size = '28px',
                                            iconSize = '18px',
                                            ...rest
                                        }) => {
    const TAG = "EventReminderButton";

    const {getConfig} = useConfig();
    const theme = useTheme();

    useEffect(() => {

    }, []);

    return (canShowEventReminderButton() && <ThemedButton
            className={`p-1 px-2 text-nowrap transition fs-sm fw-semi-bold ${circular ? '' : 'w-auto'} ${className}`}
            width={circular ? size : ''}
            height={size}
            transitionVariant={''}
            outlined={true}
            circular={circular}
            // mx={'2'}
            variant={theme.primaryBlue}
            hoverBgColor={theme.primaryBlue20}
            hoverColor={theme.primaryBlueDark}
            rippleColor={theme.primaryBlue40}
            hoverBorderColor={theme.primaryBlue}
            icon={EVT_ALERT_ICON}
            iconSize={iconSize}
            iconAsImage={true}
            // disabled={true}
            disableVariant={'xl'}
            text={circular ? '' : "Send Event Reminder"}
            tooltip={circular ? "Send Event Reminder" : ''}
            onClick={onClick}
            style={style}
            {...rest}
        />
    )


    function canShowEventReminderButton() {
        // return Object.values(EventModules).some((item) => item == getConfig(Keys.tracker_currPageModule));
        return true;
    }
});
export default EventReminderButton;
